import Commons from '../../../../Services/Common/Common';

/**
 * 그리드 필드: PL_TYPE, PL_TYPE_NM, PRO_ID, PRO_CONTENT (기존 화면과 동일).
 * API 본문: PascalCase 키 + 암호화 문자열.
 */
export const IND_BASIC_Schema = {
  fieldsProgramLink: {
    PL_TYPE: { initial: '', label: '구분', required: 'Y' },
    PRO_ID: { initial: '', label: '프로그램ID', required: 'Y' },
  },
  mapper: {
    search1: {
      Params: (_, context) =>
        Commons.EncryptAES(String(context.params ?? '').trim()) || '',
    },
    search2: {
      PlType: (_, context) =>
        Commons.EncryptAES(String(context.plType ?? '').trim()) || '',
    },
    search3: {
      PlType: (_, context) =>
        Commons.EncryptAES(String(context.plType ?? '').trim()) || '',
    },
    save1: {
      UserId: (_, context) => context.userInfo?.userid || '',
      PlType: (row) =>
        Commons.EncryptAES(row.PL_TYPE ?? row.plType ?? '') || '',
      ProId: (row) =>
        Commons.EncryptAES(row.PRO_ID ?? row.proId ?? '') || '',
    },
    delete1: {
      PlType: (row) =>
        Commons.EncryptAES(row.PL_TYPE ?? row.plType ?? '') || '',
      ProId: (row) =>
        Commons.EncryptAES(row.PRO_ID ?? row.proId ?? '') || '',
    },
  },
};
